import { styled, useDripsyTheme } from 'dripsy';
import { LinearGradient } from 'expo-linear-gradient';

import React from 'react';
import { TextSmall } from '../typography';

const Gradient = styled(LinearGradient)();

interface BetaBadgeProps {}

export const BetaBadge: React.FC<BetaBadgeProps> = ({ children, ...props }) => {
  const { theme } = useDripsyTheme();

  return (
    <Gradient
      colors={['#F3E3B4', '#E3B354']}
      sx={{
        borderRadius: 100,
        paddingX: '$2',
        paddingY: 2
      }}
      start={{ x: 0.5, y: 0.0 }}
      end={{ x: 1, y: 0.0 }}>
      <TextSmall semiBold sx={{ color: '#FFF' }}>
        Beta
      </TextSmall>
    </Gradient>
  );
};
